import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=78e5db4b&scoped=true"
import script from "./HeaderNotice.vue?vue&type=script&lang=js"
export * from "./HeaderNotice.vue?vue&type=script&lang=js"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&id=78e5db4b&prod&lang=css"
import style1 from "./HeaderNotice.vue?vue&type=style&index=1&id=78e5db4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e5db4b",
  null
  
)

export default component.exports